import { useLoadScript } from "@react-google-maps/api";

const libraries = ["places"];

export function useLoadMap(options: any = {}) {
  return useLoadScript({
    ...options,
    googleMapsApiKey: process.env.REACT_APP_GMAP_API_KEY,
    libraries,
  });
}
